/**
 * 客服任务相关请求
 */
import request from "@/utils/request";

export interface ServiceTaskListRequestParams {
    page: number;
    limit: number;
}

/**
 * 资源描述
 * create by jt -2023/6/29
 *
 * ResourceItem
 */
export interface ResourceItem {
    contentType?: null | string;
    fileName?: null | string;
    key?: null | string;
    [property: string]: any;
}

/**
 * com.anchezhixing.commonMapper.carMaintenance.dto.ResourceViewDto
 *
 * ResourceViewDto
 */
export interface ResourceViewDto {
    /**
     * 文件存储在哪个ossbucket里, 没有使用默认bucket
     */
    bucket?: null | string;
    contentType?: null | string;
    fileName?: null | string;
    key?: null | string;
    order?: number | null;
    url?: null | string;
    [property: string]: any;
}

/**
 * com.anchezhixing.commonMapper.callRecord.dto.CustomerTaskRecordDto
 *
 * CustomerTaskRecordDto
 */
export interface CustomerTaskRecordDto {
    adasOnlineState?: null | string;
    /**
     * ADAS图片OSS bucket
     */
    adasPicBucket?: null | string;
    /**
     * ADAS图片OSS key
     */
    adasPicKey?: null | string;
    adasPicUrl?: null | string;
    aebOnlineState?: null | string;
    aiCallResult?: null | string;
    assignCustomer?: null | string;
    assignCustomerId?: number | null;
    beginDealTime?: null | string;
    /**
     * BSD图片OSS bucket
     */
    bsdPicBucket?: null | string;
    /**
     * BSD图片OSS key
     */
    bsdPicKey?: null | string;
    bsdPicUrl?: null | string;
    callDuration?: number | null;
    calledAt?: null | string;
    /**
     * 关联外呼明细ID
     */
    calloutItemId?: number | null;
    carDriver?: null | string;
    carDriverPhone?: null | string;
    /**
     * 车队长
     */
    carPrincipal?: null | string;
    /**
     * 车队长电话
     */
    carPrincipalPhone?: null | string;
    channel?: null | string;
    company?: null | string;
    /**
     * 客服时间
     */
    createdAt?: null | string;
    creator?: null | string;
    creatorId?: number | null;
    customerEmotion?: null | string;
    dealCustomer?: null | string;
    dealCustomerId?: number | null;
    /**
     * 处理类型:0-人工,1-智能
     */
    dealType?: number | null;
    deviceOnlineAt?: null | string;
    deviceStatus?: null | string;
    /**
     * 设备类型
     */
    deviceType?: number | null;
    /**
     * 设备类型
     */
    deviceTypeStr?: null | string;
    district?: null | string;
    /**
     * DMS图片OSS bucket
     */
    dmsPicBucket?: null | string;
    /**
     * DMS图片OSS key
     */
    dmsPicKey?: null | string;
    dmsPicUrl?: null | string;
    endDealTime?: null | string;
    endStatus?: null | string;
    ex?: null | string;
    expectedTime?: null | string;
    expire?: null | string;
    frameNumber?: null | string;
    id?: number | null;
    insurer?: null | string;
    jt808OnlineTime?: null | string;
    lastAssignUser?: null | string;
    lat?: null | string;
    linkman?: null | string;
    lon?: null | string;
    maintenanceAddress?: null | string;
    maintenanceDate?: null | string;
    masterProblem?: null | string;
    nickName?: null | string;
    onePersonFlag?: number | null;
    onlineAt?: null | string;
    onlineState?: null | string;
    operationTime?: null | string;
    orderCode?: null | string;
    /**
     * @ExcelProperty(value = "工单id",order = 6)
     */
    orderId?: number | null;
    plateNumber?: null | string;
    recordingBucket?: null | string;
    recordingKey?: null | string;
    recordingUrl?: null | string;
    remark?: null | string;
    resources?: ResourceItem[] | null;
    resourcesJson?: null | string;
    resourceViewDtos?: ResourceViewDto[] | null;
    sessionId?: null | string;
    sessionSummary?: null | string;
    slaveProblem?: null | string;
    state?: number | null;
    taskState?: number | null;
    tel?: null | string;
    type?: null | string;
    workOrderInfo?: null | string;
    [property: string]: any;
}

/**
 * 客服任务列表查询入参
 */
export interface CustomerTaskListRequest {
    assignCustomer?: string;
    beginDate?: string;
    channel?: string;
    /**
     * 联系电话(可以同时搜索负责人 司机 车队长的电话)
     */
    commonPhone?: string;
    company?: string;
    creator?: string;
    dealBeginDate?: string;
    dealEndDate?: string;
    /**
     * 处理类型:0-人工,1-智能
     */
    dealType?: number | null;
    /**
     * 设备类型
     */
    deviceType?: number;
    endDate?: string;
    expectBeginDate?: string;
    expectEndDate?: string;
    export?: boolean;
    frameNumber?: string;
    ignoreColumns?: string[];
    insurer?: string;
    limit?: number;
    /**
     * 主问题
     */
    masterProblem?: string;
    page?: number;
    plateNumber?: string;
    "query.key"?: string;
    shard?: boolean;
    /**
     * 排序 正序： true 倒序：false
     */
    sort?: boolean;
    state?: string[];
    tel?: string;
    type?: string[];
    [property: string]: any;
}

/**
 * R«List«CustomerTaskRecordDto»»
 */
export interface CustomerTaskListResponse {
    code?: number | null;
    count?: number | null;
    data?: CustomerTaskRecordDto[] | null;
    ignoreColumns?: string[] | null;
    msg?: null | string;
    success?: boolean | null;
    [property: string]: any;
}

export const serviceTaskListRequestPath = '/api/v2/customerTask/list';

// 获取数据
export const serviceTaskListRequest = (params: CustomerTaskListRequest) => {
    return request.get<CustomerTaskListResponse>(serviceTaskListRequestPath, {
        params,
    })
}

// 添加数据
export const upsertServiceTask = (data: any) => {
    return request.post('/api/v2/customerTask/upsert', data)
}

// 删除用户
export const DeleteServiceTask = (id: number) => {
    return request.delete(`/api/v2/customerTask/${id}`)
}

// 获取数据
export const commentListRequest = (params: ServiceTaskListRequestParams) => {
    return request.get('/api/v2/commentRecord/list', {
        params,
    })
}

// 添加评论
export const upsertTaskDetail = (data: any) => {
    return request.post('/api/v2/commentRecord/upsert', data)
}

// 删除评论
export const deleteTaskRecoed = (id: number) => {
    return request.delete(`/api/v2/commentRecord/${id}`)
}

// 批量导入
export const importServiceTaskRequestPath = '/api/v2/customerTask/import';

//批量分配客服
export const batchAssignServiceTask = (data: CustomerTaskAssignerUpdateDto) => {
    return request.post('/api/v2/customerTask/updateAssignCustomer', data)
}
/**
 * CustomerTaskAssignerUpdateDto
 */
export type CustomerTaskAssignerUpdateDto = {
    /**
     * 分配的客服 人员 id administrator
     */
    assignCustomerId: number;
    /**
     * 客服任务id 数组
     */
    ids: number[];
    [property: string]: any;
}

//增加续管车客服已介入
export const addContinueServiceTask = (data: CustomerInterventionRecord) => {
    return request.post<RBooleanResponse>('/api/v2/customerIntervention/insert', data)
}
/**
 * CustomerInterventionRecord
 */
export type CustomerInterventionRecord = {
    carId?: number | null;
    createTime?: null | string;
    id?: number | null;
    nickname?: null | string;
    updateTime?: null | string;
    usedFlag?: number | null;
    userId?: number | null;
    [property: string]: any;
}
/**
 * R«Boolean»
 */
export type RBooleanResponse = {
    code?: number | null;
    count?: number | null;
    data?: boolean | null;
    ignoreColumns?: string[] | null;
    msg?: null | string;
    success?: boolean | null;
    [property: string]: any;
}

// 派发智能体任务
export interface AgentCalloutRequestDto {
    /**
     * 客服任务ID列表
     */
    customerTaskIds?: number[] | null;
    agentId?: number | null;
    [property: string]: any;
}

export interface AgentCalloutResultDto {
    /**
     * 被叫数量(合并后电话数量)
     */
    calleeCount?: number | null;
    /**
     * 外呼任务ID(本地数据库)
     */
    calloutTaskId?: number | null;
    /**
     * 关联客服任务数量(合并前)
     */
    customerTaskCount?: number | null;
    /**
     * 错误信息
     */
    errorMessage?: null | string;
    /**
     * 是否成功
     */
    success?: boolean | null;
    /**
     * 腾讯云返回的TaskId
     */
    tencentTaskId?: number | null;
    [property: string]: any;
}

export interface AssignAgentTasksResponse {
    code?: number | null;
    count?: number | null;
    data?: AgentCalloutResultDto;
    ignoreColumns?: string[] | null;
    msg?: null | string;
    success?: boolean | null;
    [property: string]: any;
}

export const dispatchAgentTask = (data: AgentCalloutRequestDto) => {
    return request.post<AssignAgentTasksResponse>('/api/v2/customerTask/assignAgentTasks', data)
}